import { Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialogConfig, MatDialogRef, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'mc-app-getting-started-dialog',
    templateUrl: './app-getting-started-dialog.component.html',
    styleUrls: ['./app-getting-started-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatIconButton, MatDialogClose, MatIcon, MatDialogTitle, CdkScrollable, MatDialogContent, MatCheckbox, MatDialogActions, MatButton]
})
export class AppGettingStartedDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<AppGettingStartedDialogComponent, void>>(MatDialogRef);

  static DialogConfig: MatDialogConfig = {
    width: '44rem'
  };

  @ViewChild('disableGettingStartedMessageCheckbox', { static: true }) disableGettingStartedMessageCheckbox: MatCheckbox;

  disableGettingStartedDialog: boolean;

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => {
      this.disableGettingStartedDialog = this.disableGettingStartedMessageCheckbox.checked;
    });
  }
}
